import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scorri verso l'inizio della pagina
  }, [pathname]); // Triggera ogni volta che cambia il percorso

  return null;
};

export default ScrollToTop;
